import type {UUID} from 'src/typings';
import type {AllDayReportsHoursSum} from './types';
import type {AjaxService} from 'core/data-services/ajax.service';

export class ReportDetailDataService {
    public static serviceName = 'reportDetailDataService';

    private static readonly ALL_DAY_REPORTS_HOURS_SUM = 'work-attendance/all-day-reports-hours-sum';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async getAllDayReportsHoursSum(dateIso: string, userRecordId: UUID): Promise<AllDayReportsHoursSum> {
        return this.ajaxService
            .createRequest(`${ReportDetailDataService.ALL_DAY_REPORTS_HOURS_SUM}`)
            .get({
                date: dateIso,
                userRecordId
            });
    }
}